import {
  COST_BUDGET_MAINTENANCE_TABLE_COLUMNS,
  COST_BUDGET_SUPPLY_ENGINEERING_SERVICE_TABLE_COLUMNS,
  COST_BUDGET_SUPPLY_MATERIAL_ONLY_TABLE_COLUMNS,
  COST_BUDGET_SUPPLY_SITE_WORK_TABLE_COLUMNS,
  CostBudgetType,
} from '../constants'

export const getQuotationDetailTableColumnIds = ({
  costBudgetType,
  isTemplate = false,
  canRemove = true,
  isExcel = false,
}) => {
  if (!Object.values(CostBudgetType).includes(costBudgetType)) {
    return []
  }

  let columnIds = []

  switch (costBudgetType) {
    case CostBudgetType.SUPPLY_MATERIAL_ONLY:
      columnIds = COST_BUDGET_SUPPLY_MATERIAL_ONLY_TABLE_COLUMNS
      break
    case CostBudgetType.SUPPLY_SITE_WORK:
    case CostBudgetType.SUPPLY_SITE_WORK_RFQ:
      columnIds = COST_BUDGET_SUPPLY_SITE_WORK_TABLE_COLUMNS
      break
    case CostBudgetType.SUPPLY_MAINTENANCE_SERVICE:
      columnIds = COST_BUDGET_MAINTENANCE_TABLE_COLUMNS
      break
    case CostBudgetType.SUPPLY_ENGINEERING_SERVICE:
      columnIds = COST_BUDGET_SUPPLY_ENGINEERING_SERVICE_TABLE_COLUMNS
      break
    default:
      columnIds = []
  }

  if (canRemove) {
    columnIds = ['action', ...columnIds]
  }
  if (isTemplate) {
    columnIds = columnIds.filter((id) => !['unitRate', 'discount', 'totalPrice', 'ECCNDetail'].includes(id))
  }
  if (isExcel) {
    columnIds = columnIds.filter((id) => !['ECCNDetail'].includes(id))
  }

  return columnIds
}
